import React from 'react';

import { Notification } from '../../components/Notification/Notification';
import { useOptionsControl } from '../../hooks/useOptionsControl';

export function RestockNotificationContainer() {
  const { restockNotiStatus, setRestockNotiStatus } = useOptionsControl();

  return <Notification status={restockNotiStatus} onClose={() => setRestockNotiStatus(null)} />;
}
